export default __webpack_public_path__ + "static/media/calculator_banner.432ece16.png";